import { useRef, useEffect, useCallback, type RefObject } from 'react';

interface UseScrollToBottomOptions {
  scrollContainerRef: RefObject<HTMLDivElement>;
  dependencies: unknown[];
}

/**
 * Hook to scroll to the bottom of a container when triggered.
 * Uses a ref flag to avoid extra re-renders and waits for the next
 * render cycle to ensure DOM is updated before scrolling.
 */
export const useScrollToBottom = ({ scrollContainerRef, dependencies }: UseScrollToBottomOptions) => {
  const pendingScrollRef = useRef(false);

  useEffect(() => {
    if (pendingScrollRef.current) {
      const scrollContainer = scrollContainerRef.current?.querySelector('[data-testid="scrollable-container"]');
      if (scrollContainer) {
        scrollContainer.scrollTop = scrollContainer.scrollHeight;
      }
      pendingScrollRef.current = false;
    }
  }, dependencies);

  const triggerScrollToBottom = useCallback(() => {
    pendingScrollRef.current = true;
  }, []);

  return { triggerScrollToBottom };
};
